import { Location } from '@reach/router';
import * as React from 'react';
import * as url from 'url';
import AppConfig from '../AppConfig';
import Breadcrumbs from '../Breadcrumbs';
const RouteBreadcrumbs = ({ homeLabel = 'Trang chủ', route, theme, }) => (React.createElement(Location, null, ({ location }) => {
    return (React.createElement(AppConfig, null, ({ rootUrl }) => (React.createElement(Breadcrumbs, { items: [
            { to: { name: 'home' }, label: homeLabel },
            {
                label: route.heading && route.heading.title,
                href: rootUrl
                    ? url.resolve(rootUrl, location.pathname)
                    : location.pathname,
                disableLink: true,
            },
        ], theme: theme }))));
}));
export default RouteBreadcrumbs;
//# sourceMappingURL=index.js.map